export type UserConsentLocation = 'CA' | 'GHPSC' | 'UK_EEA' | 'US' | 'DEFAULT';

export type SignInStatus = 'Pending' | 'Passworded' | 'Passwordless' | 'PasswordlessNewAccount' | 'Creating';

export type PianoUserType = 'password' | 'passwordless' | 'not-found';

export const UNEXPECTED_ERROR_MESSAGE = 'An unexpected error occurred. Please try again.';

export const USER_TYPE_TO_SIGNIN_STATUS: Record<PianoUserType, SignInStatus> = {
  'not-found': 'Creating',
  password: 'Passworded',
  passwordless: 'Passwordless',
};

export const SOCIAL_LOGIN_STATUSES: SignInStatus[] = ['Pending', 'Creating', 'Passworded'];

export enum SocialType {
  Apple = 'apple',
  Google = 'google',
  Facebook = 'facebook',
}

export const SOCIAL_TYPE_VALUES = Object.values(SocialType) as string[];

export function isSocialType(value: unknown): value is SocialType {
  return typeof value === 'string' && SOCIAL_TYPE_VALUES.includes(value);
}

export type SocialLoginTypeError = 'Unknown' | SocialType;

export interface SocialUrls {
  [SocialType.Apple]?: string;
  [SocialType.Google]?: string;
  [SocialType.Facebook]?: string;
}
